var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shapes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49997 11.54C6.42756 11.5409 6.35571 11.5271 6.28871 11.4996C6.22171 11.4722 6.16093 11.4315 6.10997 11.38L0.719971 6.00002L6.10997 0.60002C6.21341 0.496586 6.35369 0.438477 6.49997 0.438477C6.64625 0.438477 6.78654 0.496586 6.88997 0.60002C6.99341 0.703454 7.05151 0.843741 7.05151 0.99002C7.05151 1.1363 6.99341 1.27659 6.88997 1.38002L2.27997 6.00002L6.88997 10.61C6.99138 10.7145 7.0481 10.8544 7.0481 11C7.0481 11.1456 6.99138 11.2855 6.88997 11.39C6.83819 11.4397 6.77703 11.4785 6.71007 11.5043C6.64311 11.53 6.57168 11.5422 6.49997 11.54Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.57cfe592b4a7a20e68d4064c2b77cab1.svg";
export { ForwardRef as ReactComponent };